import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { TERMS_SECTIONS } from "@/lib/content/terms";
import type { TermsDialogProps } from "./TermsDialog.types";
import * as styles from "./TermsDialog.styles";

export type { TermsDialogProps } from "./TermsDialog.types";

export const TermsDialog = memo(function TermsDialog({
  open,
  onClose,
  onAccept,
  showAcceptButton = false,
}: TermsDialogProps) {
  const { t: tAuth } = useTranslation("auth");
  const { t } = useTranslation("terms");

  return (
    <Dialog open={open} onClose={onClose} slotProps={{ paper: { sx: styles.paper } }}>
      <DialogTitle>{tAuth("terms_and_conditions")}</DialogTitle>
      <DialogContent sx={styles.content}>
        {TERMS_SECTIONS.map((section) => (
          <div key={section.id}>
            <Typography sx={styles.sectionTitle}>{t(section.titleKey)}</Typography>
            <Typography variant="body2" sx={styles.sectionBody}>
              {t(section.bodyKey)}
            </Typography>
          </div>
        ))}
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} variant="outlined">
          {showAcceptButton ? tAuth("cancel", { defaultValue: "بستن" }) : tAuth("close", { defaultValue: "بستن" })}
        </Button>
        {showAcceptButton && onAccept ? (
          <Button onClick={onAccept} variant="contained">
            {tAuth("accept_terms")}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
});
